var React = require('react');

function BlogTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3327 1.99999C14.6943 2.45031 13.9874 2.79473 13.2393 3.01999C12.8378 2.55833 12.3042 2.23112 11.7107 2.08261C11.1172 1.9341 10.4923 1.97145 9.92073 2.18963C9.34912 2.4078 8.85831 2.79626 8.51467 3.30247C8.17103 3.80868 7.99115 4.40822 7.99935 5.01999V5.68666C6.82777 5.71704 5.66686 5.4572 4.62002 4.93029C3.57318 4.40338 2.67289 3.62575 1.99935 2.66666C1.99935 2.66666 -0.667318 8.66666 5.33268 11.3333C3.9597 12.2653 2.32412 12.7326 0.666016 12.6667C6.66601 16 13.9993 12.6667 13.9993 4.99999C13.9987 4.81429 13.9809 4.62905 13.946 4.44666C14.6264 3.77565 15.1066 2.92847 15.3327 1.99999V1.99999Z","fill":"white"}));
}

BlogTwitter.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = BlogTwitter;

BlogTwitter.default = BlogTwitter;
